import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useCallback } from "react";
import { useAppUnblocker } from "../../hooks/useAppBlocker";
import { getEmulating, setEmulating } from "../../redux/slices/env";
import { AdminSections, paths } from "@/shared/refs/paths";
import { Box, Button, Icon, InlineGrid, Text } from "@shopify/polaris";
import { AlertTriangleIcon, ExternalIcon } from "@shopify/polaris-icons";
import { useNavigate } from "react-router-dom";
import { getFirestorePath } from "@/shared/utils/db";
import { FirestorePaths } from "@/shared/consts/db";

export default function BottomBarEmulator() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const emulating = useAppSelector(getEmulating);

  const unblocker = useAppUnblocker();

  const stopEmulating = useCallback(() => {
    unblocker();
    navigate(paths.adminSection(AdminSections.SHOPS));
    dispatch(setEmulating(null));
  }, [dispatch, navigate, unblocker]);

  if (!emulating) return null;

  return (
    <Box>
      <div className="AC-Emulator-Bar">
        <Box background="bg-fill-warning" padding="200" data-bottom-bar>
          <InlineGrid columns="auto 1fr auto auto" alignItems="center" gap="100">
            <Icon source={AlertTriangleIcon} />
            <Text as="h2" variant="headingMd">
              {`Emulating - ${emulating}`}
            </Text>
            <Button
              variant="tertiary"
              url={paths.firestoreUri(
                import.meta.env.VITE_FIREBASE_PROJECT_ID,
                getFirestorePath(FirestorePaths.SHOP_DOC, { shop: emulating })
              )}
              target="_blank"
              icon={ExternalIcon}
            >
              Database
            </Button>
            <Button onClick={stopEmulating}>Stop emulating</Button>
          </InlineGrid>
        </Box>
      </div>
    </Box>
  );
}
